import React from "react"

import { ManageProjectTeamOverlay } from "./ManageProjectTeamOverlay"
import { useManageProjectTeamOverlayModel } from "./model/useManageProjectTeamOverlayModel"
import { ManageProjectTeamOverlayPayload } from "./types/ManageProjectTeamOverlayPayload"

export interface ManageProjectTeamOverlayConnectorProps {
  payload: ManageProjectTeamOverlayPayload
}

export const ManageProjectTeamOverlayConnector = React.memo(
  (props: ManageProjectTeamOverlayConnectorProps) => (
    <ManageProjectTeamOverlay {...useManageProjectTeamOverlayModel(props)} />
  )
)
